<ng-container *ngIf="text.length <= maxLengthToShow">
    <pre>{{text}}</pre>
</ng-container>
<ng-container *ngIf="text.length > maxLengthToShow">
    <pre class="d-inline">{{ isCollapsed ? text.substring(0, maxLengthToShow) + '...' : text }}</pre>
    <a class="cursorPointer" (click)="toggleCollapse()">{{ isCollapsed ? ' Read more' : ' Read less' }}</a>
</ng-container>